import styled from 'styled-components'
import { darkOrange, blue, warmTint } from '@/theme/colors'
import { radii, media, motion } from '@/theme/tokens'
import { fontSizes, text, tracking } from '@/theme/typography'

export const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	gap: 11px;
	margin-bottom: 2px;
`

export const IconChip = styled.span`
	width: 28px;
	height: 28px;
	border-radius: ${radii.round};
	background: ${warmTint};
	color: ${darkOrange};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
`

export const Label = styled.span`
	${text.title}
	letter-spacing: ${tracking.tight};
	color: ${darkOrange};

	${media.phone} {
		font-size: ${fontSizes.title};
	}
`

/**
 * Right-aligned hover arrow. Hidden at rest; the parent tile's `:hover` fades and
 * slides it in (see `BentoTile.styles.ts`, which references this component).
 */
export const TileArrow = styled.span`
	margin-left: auto;
	color: ${blue};
	display: inline-flex;
	opacity: 0;
	transform: translateX(-4px);
	transition:
		opacity ${motion.base},
		transform ${motion.base};
`
